if (!Number.randomInt) {
    Number.randomInt = (min, max) => {
        const crypto = window.crypto || window.msCrypto;
        const r = new Uint32Array(1);
        crypto.getRandomValues(r);

        let randomNumber = r[0] / (0xffffffff + 1);

        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(randomNumber * (max - min + 1)) + min;
    }
}

if (!String.format) {
    /**
     *
     * @param {string} format
     * @return {*|void|XML|string}
     */
    String.format = function (format) {
        let splitter = '%s';
        let parts = format.split(splitter);
        let newFormat = '';

        for (let x = 0; x < parts.length; x++) {
            let r = x + 1 < 1 || arguments.length <= x + 1 ? undefined : arguments[x + 1];

            if (!r) {
                r = '';
            }

            newFormat += parts[x];
            newFormat += r;
        }

        return newFormat;
    };
}

String.prototype.isEmpty = function () {
    return this.length === 0 || !this.trim();
};

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

if (!String.join) {

    /**
     *
     * @param {string} delimiter
     * @param {...string} strings
     * @returns {string}
     */
    String.join = function (delimiter, ...strings) {
        let str = '';
        strings.forEach(function (string) {
            str += (string + delimiter);
        });

        return str.replace(delimiter, '');
    };
}

if (!String.random) {
    String.random = function (length = 16, characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
        let result = '';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Number.randomInt(0, charactersLength-1));
            counter += 1;
        }
        return result;
    }
}


if (!Array.trim) {
    /**
     *
     * @param array
     * @returns {*[]}
     */
    Array.trim = function(array) {
        let uniqueArray = [];

        array.forEach(function (value) {
            if (uniqueArray.indexOf(value) < 0) {
                uniqueArray.push(value);
            }
        });

        return uniqueArray;
    };
}


if (!Object.clean) {
    /**
     *
     * @param obj
     * @param checkEmptyStrings
     * @returns {{[p: string]: unknown}}
     */
    Object.clean = function (obj, checkEmptyStrings = false) {
        if (obj instanceof FormData) {
            return obj;
        }

        let keys = Object.entries(obj);
        let finalObj = {};

        let hasEntries = false;
        for (let [key, value] of keys) {
            if (value !== null && value !== undefined) {
                let valueType = typeof value;

                if (valueType === 'object') {
                    let cleanVal = Object.clean(value, checkEmptyStrings);
                    if (cleanVal) {
                        finalObj[key] = cleanVal;
                    }
                } else if (valueType === 'string') {
                    if (!checkEmptyStrings || !value.isEmpty()) {
                        //Añade cualquier string si checkEmptyStrings = false
                        //En caso contrario, comprueba que el string no esté vacío
                        finalObj[key] = value;
                    }
                } else {
                    finalObj[key] = value;
                }

                hasEntries = true;
            }
        }

        if (hasEntries) {
            return finalObj;
        } else {
            return null;
        }
    }
}

if (!Number.format) {
    /**
     *
     * @param {number} number
     * @param {Intl.NumberFormat} formatter
     */
    Number.format = function(number, formatter) {
        return formatter.format(number);
    }
}

if (!Blob.prototype.toBase64Data) {
    /**
     *
     * @returns {Promise<string>}
     */
    Blob.prototype.toBase64Data = function () {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = _ => {
                resolve(reader.result);
            }

            reader.readAsDataURL(this);
        })
    }
}
